import { applyStatutoryRounding } from '../../../utils/rounding';

export const formatTime = (isoString) => {
  if (!isoString) return '--:--';
  const date = new Date(isoString);
  const now = new Date();
  if ((date - now) > 30 * 24 * 60 * 60 * 1000) return 'OPEN';
  return date.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' });
};

export const formatDateTime = (isoString) => {
  if (!isoString) return '--';
  const date = new Date(isoString);
  const now = new Date();
  if ((date - now) > 30 * 24 * 60 * 60 * 1000) return 'OPEN';
  return date.toLocaleString('en-AU', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit'
  });
};

export const formatDuration = (seconds, endTs, segmentType, showStatutory) => {
  if (seconds === null || seconds === undefined) return 'OPEN';
  if (endTs) {
    const endDate = new Date(endTs);
    const now = new Date();
    if ((endDate - now) > 30 * 24 * 60 * 60 * 1000) return 'OPEN';
  }
  if (seconds < 0) return 'INVALID';

  let displaySeconds = seconds;
  if (showStatutory && segmentType) {
    displaySeconds = applyStatutoryRounding(seconds, segmentType);
  }

  const hrs = Math.floor(displaySeconds / 3600);
  const mins = Math.floor((displaySeconds % 3600) / 60);
  return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
};

export const getRestLabel = (seg) => {
  if (seg.segment_type !== 'REST') return seg.segment_type;
  const source = seg.source || '';
  const duration = seg.duration_seconds || 0;
  if (source === 'DAY_OFF' || duration >= 86400) return '24R';
  if (source === 'NIGHT_REST' || duration >= 25200) return 'ONR';
  return 'IDR';
};

export const getRestLabelFull = (seg) => {
  const label = getRestLabel(seg);
  const map = { 'IDR': 'In Day Rest', 'ONR': 'Over Night Rest', '24R': '24 Hour Rest' };
  return map[label] || label;
};

export const getRestBadgeClasses = (seg) => {
  const label = getRestLabel(seg);
  switch (label) {
    case 'IDR': return 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30';
    case 'ONR': return 'bg-sky-500/20 text-sky-400 border-sky-500/30';
    case '24R': return 'bg-violet-500/20 text-violet-400 border-violet-500/30';
    default:    return 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30';
  }
};

export const getRestLabelColor = (seg) => {
  const label = getRestLabel(seg);
  switch (label) {
    case 'IDR': return 'text-emerald-400';
    case 'ONR': return 'text-sky-400';
    case '24R': return 'text-violet-400';
    default:    return 'text-emerald-400';
  }
};
